<template>
  <fix-centerv1 class="cpr-pop-box" v-dialogDrag w="390" h="260" v-model="show" @close="onClose">
    <template slot="title">{{ popTitle }}</template>
    <div slot="main" class="daily_pop">
      <p class="pre_num">修改前:{{ preV }}</p>
      <div v-if="curKey === 'maxFlowNumPerDate'" class="input_box">
        <el-input-number placeholder="请输入修改数据" :controls="false"
          :min="0.01" :max="9999" :precision="2" :step="0.1" v-model="valueNew">
        </el-input-number>
        <i class="suffix_unit">千人次</i>
      </div>
      <div v-else class="input_box">
        <el-input-number placeholder="请输入修改数据" :controls="false" :min="1" :max="9999"
          :precision="0" :step="1" v-model="valueNew">
        </el-input-number>
        <i class="suffix_unit">{{ curKey === 'maxPointLimitFlow' ? '人次' : '次' }}</i>
      </div>
    </div>
    <template slot="btm">
      <div :class="['opt_btn','red', valueNew === undefined ? 'disable' : '']" @click="onConfirm">确认</div>
      <div class="opt_btn" @click="reset">取消</div>
    </template>
  </fix-centerv1>
</template>

<script>
import { deepClone } from '@/utils/functions'

export default {
  name: 'CprPlusDailyPop',
  props: {
    // CPR+订单 流量日限、点位日限流量、点位日限频次 初始数据
    cprDaily: {
      type: Object,
      default() {
        return {
          orderId: undefined,
          propKey: undefined,
          maxFlowNumPerDate: undefined,
          maxPointLimitFlow: undefined,
          maxPointLimitPlayCount: undefined
        }
      }
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      key2title: {
        maxFlowNumPerDate: '流量日限',
        maxPointLimitFlow: '点位日限流量',
        maxPointLimitPlayCount: '点位日限频次'
      },
      valueNew: undefined
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
    curKey() {
      return this.cprDaily.propKey
    },
    popTitle() {
      return this.curKey ? this.key2title[this.curKey] : ''
    },
    preV() {
      if (this.curKey) {
        const v = this.cprDaily[this.curKey]
        if (v) {
          switch (this.curKey) {
            case 'maxFlowNumPerDate':
              return (v / 1000).toFixed(2) + '千人次'
            case 'maxPointLimitFlow':
              return v + '人次'
            case 'maxPointLimitPlayCount':
              return v + '次'
            default:
              break;
          }
        }
        return '不限'
      }
      return '不限'
    }
  },
  methods: {
    onClose() {
      this.valueNew = undefined
    },
    reset() {
      this.show = false
      this.valueNew = undefined
    },
    async onConfirm() {
      // if (this.valueNew === undefined || this.valueNew === null) {
      //   this.$confirm(`此操作将修改${this.popTitle}为不限，是否继续?`, '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(async () => {
      //     await this.submitNewValue()
      //     this.reset()
      //   }).catch(() => {
      //   })
      // } else {
      //   await this.submitNewValue()
      //   this.reset()
      // }
      if (this.valueNew === undefined || this.valueNew === null) return // 未输入数值不可提交
      await this.submitNewValue()
      this.reset()
    },
    async submitNewValue() {
      const { propKey, orderId, ...kObj } = this.cprDaily
      const param = deepClone(kObj)
      if (propKey === 'maxFlowNumPerDate') {
        param[propKey] = this.valueNew * 1e3 // 流量日限"千人次"转为"人次"
      } else {
        param[propKey] = this.valueNew
      }
      const res = await this.fetch(`/orderlite/compatible/web/order/v2/order/${orderId}/dmpLimit`, param, 'put')
      if (res && res.code === 0) {
        this.messageTip(res.msg || '修改成功', 1)
        this.$emit('refresh')
      }
    }
  }
}
</script>

<style lang="scss">
.cpr-pop-box .fix-center-main {
  background-color: #F5F5F5;
}
</style>
<style lang="scss" scoped>
.daily_pop {
  width: 100%;
  height: 100%;
  background-color: #FFF;
  padding: 20px;
  .pre_num {
    height: 20px;
    margin-bottom: 10px;
  }
  .input_box {
    position: relative;
    // height: 40px;
    ::v-deep .el-input-number {
      width: 100%;
      .el-input__inner {
        height: 40px;
        line-height: 40px;
        border: none;
        box-shadow: 0 0 0 1px #E9E9E9;
        padding: 0 10px;
        text-align: left;
      }
    }
    .suffix_unit {
      width: 65px;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      text-align: right;
    }
  }
}
.opt_btn {
  display: inline-block;
  margin: 15px 10px;
  width: 68px;
  height: 30px;
  line-height: 28px;
  text-align: center;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e9e9e9;
  cursor: pointer;
  &.red {
    background: linear-gradient(315deg,rgba(255,132,109,1) 0%,rgba(255,57,115,1) 100%);
    color: #fff;
  }
  &.disable {
    cursor: not-allowed;
    opacity: 0.3;
  }
}
</style>
